import { axiosInstance } from "../axios";

export const loginMaxx = async ({ username, password }) => {
    return axiosInstance
        .post(`/maxx/login/`, {
            username,
            password
        })
};